module.exports = __webpack_public_path__ + "bed-temp-frame.aec07717.png";